import { getPid, parseUser, trimProviderId } from '@services/api'
import type { LoginType } from '@services/api/auth.api'
import { getAccessToken } from '@services/auth/accessTokenStore'

const STAFF: LoginType = 'staff'

type AccessTokenClaims = {
  sub?: string
  sub_typ?: string
  provider_id?: string
}

/** Same JWT payload decode staffScope uses for `scp`. */
const claimsFromAccessToken = (): AccessTokenClaims | null => {
  const accessToken = getAccessToken()
  if (!accessToken) return null
  try {
    const segment = accessToken.split('.')[1]
    if (!segment) return null
    let base64 = segment.replace(/-/g, '+').replace(/_/g, '/')
    const pad = base64.length % 4
    if (pad) base64 += '='.repeat(4 - pad)
    return JSON.parse(atob(base64)) as AccessTokenClaims
  } catch {
    return null
  }
}

const loginTypeFromAccessToken = (): LoginType | null => {
  const subTyp = claimsFromAccessToken()?.sub_typ
  if (subTyp === 'staff' || subTyp === 'user') return subTyp
  return null
}

export const isStaff = (): boolean =>
  parseUser()?.login_type === STAFF || loginTypeFromAccessToken() === STAFF

/** Provider id written by auth.reducer on login / verifyToken. */
export const readPid = (): string | null => {
  const fromStoredProvider = getPid()
  if (fromStoredProvider) return fromStoredProvider

  const jwtPid = trimProviderId(claimsFromAccessToken()?.provider_id)
  if (jwtPid) return jwtPid

  const u = parseUser()
  if (u?.user_id && isStaff()) return u.user_id

  const jwtSub = claimsFromAccessToken()?.sub?.toString().trim()
  if (jwtSub && isStaff()) return jwtSub
  return null
}
